module.exports = __webpack_public_path__ + "img/not-team-header-icon.06803631.png";